
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contacts/create",
      function () {
        return require("private-next-pages/contacts/create/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contacts/create"])
      });
    }
  